import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { addNotification } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications';

export function useCopyToClipboard(valueToCopy: string) {
  const { t } = useTranslation();
  const dispatchAddNotification = useAction(addNotification);
  return useCallback(() => {
    /**
     * navigator.clipboard only works in secure contexts, so we have to check for that before trying this.
     * https://w3c.github.io/clipboard-apis/#clipboard-item-interface
     *
     * Note the `[SecureContext]` attribute.
     */
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
        .writeText(valueToCopy)
        .then(() => {
          dispatchAddNotification(NotificationType.Generic, {
            message: t('common.copyToClipboard.generic.success'),
          });
        })
        .catch(() => {
          dispatchAddNotification(NotificationType.Generic, {
            message: t('common.copyToClipboard.generic.error'),
          });
        });
    } else {
      dispatchAddNotification(NotificationType.Generic, {
        message: t('common.copyToClipboard.secureContext.error'),
      });
    }
  }, [t, valueToCopy, dispatchAddNotification]);
}
